module.exports = __webpack_public_path__ + "static/media/client.414309b8.jpg";